import { PayrollCountryType } from '@nxsys/types/models/Common';
import { roles } from '@nxsys/store/constants';
import { lazy } from 'react';


const SubmitPSR = lazy(
  () => import('../../../modules/submitPSR'),
);

// NX-6140: filings grouped by submission. The per-worker list above stays -
// it is still the right view for everything filed before batching.
const PSRBatchListing = lazy(
  () => import('../../../modules/revenueFilings/listing/PSRBatch'),
);

// A page, not a dialog: the detail carries a payslip table plus the full
// request and response documents, which is more than a modal can show without
// nesting scrollbars. Mirrors how FPS details work for the UK.
const PSRSubmissionDetails = lazy(
  () => import('../../../modules/revenueFilings/details/PSRSubmission'),
);

export const revenueFilingsHistoryConfig = (
  payrollCountry: PayrollCountryType,
) => {
  if (payrollCountry !== 'IRELAND') return [];
  return [
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/revenue-filings/psr-submissions',
      element: <PSRBatchListing />,
    },
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/revenue-filings/psr-submissions/:id',
      element: <PSRSubmissionDetails />,
    },
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/revenue-filings/submit-psr',
      element: <SubmitPSR />,
    },
  ];
};
